import React from 'react';
import { useHistory } from 'react-router';

import NextButton from '../NextButton/NextButton';

import styles from './PINReset.scss';
import PINResetContent from './PINResetContent/PINResetContent';

const PINReset: React.FC = () => {
  const history = useHistory();

  return (
    <>
      <PINResetContent />
      <NextButton className={styles.next} block onClick={history.goBack} />
    </>
  );
};

export default PINReset;
